import classNames from "classnames";
import PropTypes from "prop-types";

import classes from "./grid.module.scss";

function Grid({
  rows,
  columns,
  rowGap,
  columnGap,
  justify,
  align,
  layout,
  className,
  style: customStyle,
  children,
}) {
  const style = {
    gridTemplateRows: rows,
    gridTemplateColumns: columns,
    rowGap,
    columnGap,
    justifyItems: justify,
    alignItems: align,
    gridTemplateAreas: layout.map((row) => `"${row.join(" ")}"`).join(" "),
    ...customStyle,
  };

  const elements = Array.isArray(children) ? children : [children];

  return (
    <div className={classNames(classes.grid, className)} style={style}>
      {elements.map((el, index) => (
        <el.type
          {...el.props}
          key={el.props.id || index}
          style={{ ...el.props.style, gridArea: el.props.id }}
        />
      ))}
    </div>
  );
}

Grid.propTypes = {
  rows: PropTypes.string.isRequired,
  columns: PropTypes.string.isRequired,
  rowGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  columnGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  justify: PropTypes.oneOf(["start", "end", "center", "stretch"]).isRequired,
  align: PropTypes.oneOf(["start", "end", "center", "stretch"]).isRequired,
  layout: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string).isRequired)
    .isRequired,
  className: PropTypes.string.isRequired,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
};

Grid.defaultProps = {
  rows: "auto",
  columns: "auto",
  rowGap: 0,
  columnGap: 0,
  justify: "stretch",
  align: "stretch",
  layout: [[]],
  className: "",
  children: [],
};

export default Grid;
